import { makeStyles } from '@mui/styles';

const drawerWidth = 240;

const colors = {
  button: {
    primary: '#00C051',
    secondary: '#B7FFBD',
    text: 'black',
  },
};

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(2),
      },
    },
    list_title: {
      paddingLeft: '15%',
      paddingRight: '15%',
    },
    list: {
      width: '100%',
      position: 'relative',
      overflow: 'auto',
      // maxHeight: 350,
    },
    roottab: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
      display: 'flex',
    },
    tabs: {
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    notifications: {
      marginRight: theme.spacing(1),
    },
    textField: {
      margin: theme.spacing(1),
      color: 'red',
      '&:invalid': {
        border: 'red solid 2px',
      },
    },
    rootMenu: {
      display: 'flex',
    },
    drawer: {
      [theme.breakpoints.up('sm')]: {
        width: drawerWidth,
        flexShrink: 0,
      },
      '& .MuiListItemButton-root.Mui-selected': {
        backgroundColor: '#B7FFBD',
      },
      '& .MuiMenuItem-root.Mui-selected': {
        backgroundColor: '#B7FFBD',
      },
    },
    appBar: {
      display: 'flex',

      zIndex: theme.zIndex.drawer + 1,
      background:
        process.env.REACT_APP_PLATAFORM === 'crevettic' ? '#FFFFFF' : '#fff',
    },
    titleButtonBar: {
      fontSize: '1.15em',
      fontWeight: 'bold',
      justifyContent: 'flex-end',
      color:
        process.env.REACT_APP_PLATAFORM === 'crevettic' ? '#545454' : 'black',
      // flexGrow: 1,
    },
    title: {
      flexGrow: 1,
    },
    nested: {
      paddingLeft: theme.spacing(8),
    },
    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
    // necessário para que o conteúdo esteja abaixo da barra do aplicativo
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: 'black',
    },
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
      width: drawerWidth,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    rootDelete: {
      background: '#c70000',
      '&:hover': {
        backgroundColor: '#b30000',
      },
      '& > *': {
        margin: theme.spacing(0.75),
      },
    },
    fab: {
      position: 'fixed',
      bottom: theme.spacing(2),
      right: theme.spacing(2),
      background:
        process.env.REACT_APP_PLATAFORM === 'crevettic' ? '#F55420' : '#fff',
      color:
        process.env.REACT_APP_PLATAFORM === 'crevettic' ? 'white' : 'black',
      '&:hover': {
        backgroundColor:
          process.env.REACT_APP_PLATAFORM === 'crevettic'
            ? '#fa8c3a'
            : '#f0f0f0',
      },
    },
    fabdownload: {
      bottom: theme.spacing(10),
    },
    fabwhats: {
      position: 'fixed',
      bottom: theme.spacing(2),
      right: theme.spacing(2),
      backgroundColor: '#34af23',
      '&:hover': {
        backgroundColor: '#34ad00',
      },
      color: 'white',
    },
    saveButton: {
      background: '#0267C1',
      '&:hover': {
        backgroundColor: '#015cad',
      },
      '& > *': {
        margin: theme.spacing(0.75),
      },
    },
    buttonPrimary: {
      background: '#5ebe00',
      // width: "95%",
      '&:hover': {
        backgroundColor: '#52a600',
      },
      '& > *': {
        margin: theme.spacing(0.75),
      },
    },
    buttonRegister: {
      background: colors.button.primary,
      color: '#FFFFFF',
      '&:hover': {
        backgroundColor: colors.button.secondary,
        color: colors.button.text,
      },
      '& > *': {
        margin: theme.spacing(0.75),
      },
    },
    generateReportButton: {
      backgroundColor: colors.button.primary,
      color: '#FFF',
      '&:hover': {
        backgroundColor: colors.button.secondary,
        color: colors.button.text,
      },
      borderRadius: '15px',
    },
    addRecordLineButton: {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: colors.button.primary,
      transition: 'all 0.2s',
      '&:hover': {
        backgroundColor: colors.button.secondary,
        color: colors.button.text,
      },
      borderRadius: '50%',
      width: 35,
      height: 35,
    },
    addNewRecordButton: {
      backgroundColor: colors.button.primary,
      borderRadius: '50%',
      color: 'white',
      fontSize: '35px',
    },
    rootReturn: {
      background: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
      '& > *': {
        margin: theme.spacing(0.75),
      },
    },
    rootTransfer: {
      background: '#81c784',
      '&:hover': {
        backgroundColor: 'rgba(129,199,132,10)',
      },
      '& > *': {
        margin: theme.spacing(0.75),
      },
    },
    rootFinalize: {
      background: 'green',
      '&:hover': {
        backgroundColor: 'lightGreen',
      },
      '& > *': {
        margin: theme.spacing(0.75),
      },
    },
    titleTransfer: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    buttonImage: {
      color: '#222',
      margin: 5,
    },
    recaptcha: {
      display: 'flex',
      justifyContent: 'center',
      margin: 0,
    },
    footer: {
      [theme.breakpoints.up('sm')]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    avatar: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.light,
    },
    seeAccount: {
      background: '#4682B4',
      '&:hover': {
        backgroundColor: 'rgba(70,130,180, 0.92)',
      },
      height: '100%',
    },
    bold: {
      fontSize: 18,
      fontWeight: 'bold',
    },
    simple: {},
    number: {
      fontSize: 22,
      fontWeight: 'bold',
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
    },
    centralized: {
      justifyContent: 'center',
      alignItems: 'center',
    },
    roundedPaper: {
      borderRadius: '20px',
    },
    roundedButton: {
      borderRadius: '15px',
      backgroundColor: colors.button.primary,
      color: '#FFF',
      '&:hover': {
        backgroundColor: colors.button.secondary,
        color: colors.button.text,
      },
    },
  }),
  { index: 1 },
);
